import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import { useAuth } from '../../shared/hooks/useAuth';
import { config } from '../../shared/config';

type PaypalProps = {
  amount: number | null;
  status: number | null;
};

const Paypal = ({ amount, status }: PaypalProps) => {
  const { t } = useTranslation();
  const auth = useAuth();

  if (Number(status) === 3 || !config.paypalEnabled) {
    return null;
  }

  const emailContact = t('email contact');
  const searchParams = new URLSearchParams(window.location.search);
  const isPaypalSuccess = searchParams.get('paypalSuccess') === 'true';
  if (!isPaypalSuccess) {
    searchParams.set('paypalSuccess', 'true');
  }
  const returnUrl = `${document.location.href}?${searchParams.toString()}`;
  const cancelUrl = document.location.href;

  return (
    <div className="my-4">
      {isPaypalSuccess ? (
        <div className="text-xl font-semibold mb-0 xl:mb-4">{t('paypal success')}</div>
      ) : (
        <form id="pay_it" action="https://www.paypal.com/cgi-bin/webscr" method="post">
          <input type="hidden" name="business" value={emailContact} />
          <input type="hidden" name="cmd" value="_xclick" />
          <input
            id="paypal-desc"
            type="hidden"
            name="item_name"
            value={t('paypal payment descr', {
              sampleCode: auth?.user?.username ?? '',
            })}
          />
          <input id="paypal-amount" type="hidden" name="amount" value={amount ?? 0} />
          <input id="paypal-currency" type="hidden" name="currency_code" value="EUR" />
          <input id="paypal-lang" type="hidden" name="lc" value={i18n.language.toUpperCase()} />
          <input type="hidden" name="no_shipping" value="1" />
          <input id="paypal-email" type="hidden" name="email" value="" />
          <input id="paypal-return" type="hidden" name="return" value={returnUrl} />
          <input id="paypal-cancel_return" type="hidden" name="cancel_return" value={cancelUrl} />
          <input type="hidden" name="cbt" value={t('paypal back to')} />
          <input
            type="image"
            src="https://www.paypalobjects.com/it_IT/IT/i/btn/btn_buynowCC_LG.gif"
            name="submit"
            alt="PayPal - Il metodo rapido, affidabile e innovativo per pagare e farsi pagare."
          />
        </form>
      )}
    </div>
  );
};

export default Paypal;
